"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientFeatures = void 0;
const PermissionName_1 = require("../Permission/PermissionName");
const NativeFeatureIdentifier_1 = require("../Feature/NativeFeatureIdentifier");
const domain_core_1 = require("@standardnotes/domain-core");
const ttag_1 = require("ttag");
const ProductNames_1 = require("../Strings/ProductNames");
function clientFeatures() {
    return [
        {
            name: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info').t `Tag Nesting`,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TagNesting,
            permission_name: PermissionName_1.PermissionName.TagNesting,
            description: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info').t `Organize your tags into folders.`,
        },
        {
            name: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info').t `Smart Filters`,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SmartFilters,
            permission_name: PermissionName_1.PermissionName.SmartFilters,
            description: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info')
                .t `Create smart filters for viewing notes matching specific criteria.`,
        },
        {
            name: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info').t `Encrypted files`,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Files,
            permission_name: PermissionName_1.PermissionName.Files,
            description: '',
        },
        {
            name: ProductNames_1.ClipperName,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Clipper,
            permission_name: PermissionName_1.PermissionName.Clipper,
            description: '',
        },
    ];
}
exports.clientFeatures = clientFeatures;
